"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockPlaceholder = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const ui_1 = require("@jsonjoy.com/ui");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const slate_react_1 = require("slate-react");
const typeToLabel_1 = require("../../util/typeToLabel");
const context_2 = require("../../context");
const Key_1 = require("@jsonjoy.com/ui/lib/1-inline/Key");
const blockPlaceholderClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    t: '0',
    l: '0',
    pe: 'none',
    us: 'none',
    mr: '0',
    pd: 'inherit',
    lh: 'inherit',
});
const getPlaceholderText = (element) => {
    // if (element.type === 'p') return 'Type here or press "/" for options...';
    if (element.type === 'p')
        return (React.createElement(React.Fragment, null,
            "Type here",
            !ui_1.isTouch && (React.createElement(React.Fragment, null,
                "\u00A0or double tap ",
                React.createElement(Key_1.Key, null, "Shift"),
                ", ",
                React.createElement(Key_1.Key, null, "Shift"),
                " for menu")),
            "..."));
    return (0, typeToLabel_1.typeToLabel)(element.type);
};
const BlockPlaceholder = ({ element }) => {
    const mutxt = (0, context_2.useMuTxt)();
    const focused = mutxt.focused.use();
    const styles = (0, context_1.useStyles)();
    const isSelected = (0, slate_react_1.useSelected)();
    const selection = mutxt.selection.use();
    if (selection || !isSelected || !focused)
        return;
    const isEmpty = mutxt.api.isEmpty();
    if (isEmpty)
        return;
    const placeholder = getPlaceholderText(element);
    if (!placeholder)
        return;
    return (React.createElement("span", { contentEditable: false, className: blockPlaceholderClass, style: { color: styles.g(0.5) } }, placeholder));
};
exports.BlockPlaceholder = BlockPlaceholder;
